module.exports = __webpack_public_path__ + "static/media/pnbox.67074773.svg";